(function () {
  function pad2(n) {
    return String(Math.max(0, Math.min(99, n))).padStart(2, '0');
  }

  function parseEnd(raw) {
    if (!raw || typeof raw !== 'string') return NaN;
    var t = Date.parse(raw.trim());
    return Number.isFinite(t) ? t : NaN;
  }

  function headlineOverlapsTimer(headline, timer) {
    var headlineRect = headline.getBoundingClientRect();
    var timerRect = timer.getBoundingClientRect();
    var sameRow = Math.abs(headlineRect.top - timerRect.top) <= 4;
    return sameRow && headlineRect.right > timerRect.left + 0.5;
  }

  function updateRowStack(banner) {
    var headline = banner.querySelector('.product-promo-countdown-banner__headline');
    var timer = banner.querySelector('.product-promo-countdown-banner__timer');
    if (!headline || !timer || timer.hidden || banner.hidden) {
      banner.classList.remove('product-promo-countdown-banner--row-stack');
      return;
    }

    banner.classList.remove('product-promo-countdown-banner--row-stack');
    if (headlineOverlapsTimer(headline, timer)) {
      banner.classList.add('product-promo-countdown-banner--row-stack');
    }
  }

  function initRowStackLayout(banner, scheduleUpdate) {
    if (banner.dataset.rowStackInit) return;
    banner.dataset.rowStackInit = 'true';

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(scheduleUpdate);
      ro.observe(banner);
      var grid = banner.querySelector('.product-promo-countdown-banner__grid');
      if (grid) ro.observe(grid);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  }

  function bind(el) {
    if (el.dataset.countdownBound) return;
    el.dataset.countdownBound = 'true';

    var rafId = null;
    function scheduleRowStackUpdate() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateRowStack(el);
      });
    }

    initRowStackLayout(el, scheduleRowStackUpdate);
    window.addEventListener('resize', scheduleRowStackUpdate);

    var rawEnd = el.dataset.end;
    if (rawEnd == null || String(rawEnd).trim() === '') {
      el.hidden = true;
      scheduleRowStackUpdate();
      return;
    }
    var endMs = parseEnd(rawEnd);
    if (!Number.isFinite(endMs)) {
      el.hidden = true;
      scheduleRowStackUpdate();
      return;
    }

    var dEl = el.querySelector('[data-product-promo-countdown-d]');
    var hEl = el.querySelector('[data-product-promo-countdown-h]');
    var mEl = el.querySelector('[data-product-promo-countdown-m]');
    var sEl = el.querySelector('[data-product-promo-countdown-s]');

    function tick() {
      var now = Date.now();
      var remaining = endMs - now;
      if (remaining <= 0) {
        el.hidden = true;
        scheduleRowStackUpdate();
        return;
      }
      var totalSec = Math.floor(remaining / 1000);
      var days = Math.floor(totalSec / (60 * 60 * 24));
      var hours = Math.floor((totalSec % (60 * 60 * 24)) / (60 * 60));
      var mins = Math.floor((totalSec % (60 * 60)) / 60);
      var secs = totalSec % 60;
      if (dEl)
        dEl.textContent = days > 99 ? String(days) : String(Math.max(0, days)).padStart(2, '0');
      if (hEl) hEl.textContent = pad2(hours);
      if (mEl) mEl.textContent = pad2(mins);
      if (sEl) sEl.textContent = pad2(secs);
      el.hidden = false;
      scheduleRowStackUpdate();
    }

    tick();
    setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-product-promo-countdown]').forEach(bind);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
